import { axios } from '@/lib/axios';

export const logout = async (): Promise<void> => axios.post('/logout');
